import { create } from 'zustand';
import { useLoader } from '@/features/loader/store';
import type { NetworkId } from '@/features/loader/types';
import { facilityById } from './facilities';

interface CatalogueView {
  examples: boolean;
  loaderOpened: boolean;
  setExamples: (examples: boolean) => void;
  enterLoader: (explicitNetwork?: NetworkId) => void;
}

/** Session-only view choices: examples never replace the shared constellation. */
export const useCatalogueView = create<CatalogueView>((set, get) => ({
  examples: true,
  loaderOpened: false,
  setExamples: (examples) => set({ examples }),
  enterLoader: (explicitNetwork) => {
    if (explicitNetwork || !get().loaderOpened)
      useLoader
        .getState()
        .setNetwork(explicitNetwork && explicitNetwork !== 'demo' ? explicitNetwork : 'noaa');
    set({ loaderOpened: true });
  },
}));

/** Explicit twin links take precedence over the default examples view. */
export function selectTwinCatalogue(assetId: string): void {
  const loader = useLoader.getState();
  const parts = assetId.split(':');
  const facility = parts[0] === 'facility' ? facilityById(parts[1]) : undefined;
  const network = assetId.startsWith('rfims')
    ? 'rfims'
    : parts[0] === 'mission'
      ? decodeURIComponent(parts[1])
      : facility
        ? facility.members.some((m) => m.network === loader.network)
          ? loader.network
          : facility.members[0]?.network
        : parts.length > 1
          ? parts[0]
          : undefined;
  useCatalogueView.getState().setExamples(!network || network === 'demo');
  if (network && network !== 'demo' && network !== loader.network) loader.setNetwork(network);
}
